import sensors from 'sa-sdk-javascript'
import { GlobalUtil } from '@xl/js-utils'

const environment =
  process.env.NODE_ENV === 'development'
    ? 'stg'
    : document.documentElement.dataset.vanEnv || 'prod'

const SA_HOST = {
  stg: 'https://uba-stg.xiaolachuxing.com/sa?project=xluser',
  pre: 'https://uba-stg.xiaolachuxing.com/sa?project=xluser',
  prod: 'https://uba.xiaolachuxing.com/sa?project=xluser'
}[environment]

sensors.init({
  server_url: SA_HOST,
  is_track_single_page: true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
  use_client_time: true,
  send_type: 'beacon',
  heatmap: {
    // 是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
    clickmap: 'not_collect',
    // 是否开启触达注意力图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
    scroll_notice_map: 'not_collect'
  },
  show_log: true //! isProduction // 是否控制台打印日志
})

function install(Vue) {
  sensors.init({
    server_url: SA_HOST,
    is_track_single_page: true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
    use_client_time: true,
    send_type: 'beacon',
    heatmap: {
      // 是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
      clickmap: 'not_collect',
      // 是否开启触达注意力图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
      scroll_notice_map: 'not_collect'
    },
    show_log: true //! isProduction // 是否控制台打印日志
  })

  Vue.prototype.$sa = sensors
  Vue.prototype.$track = sensors.track

  sensors.registerPage({
    url: window.location.href,
    ...GlobalUtil.globalSensorProp()
  })
  sensors.quick('autoTrack')
}

export default function(Vue) {
  install(Vue)
}
